// Who may send in a conversation, from the client's point of view.
//
// Mirrors the server rule in
// Backend/supabase/functions/plenty-of-hearts/services/Messaging/messaging.service.ts:
// Message Bets are open to every tier; sending outside a bet needs a live
// subscription. The server enforces it and refuses the request either way —
// this exists so the composer can be replaced with an explanation instead of
// letting someone type a message that will be rejected.

import { Conversation } from '../types/messaging';

/**
 * Whether the viewer can send in this conversation.
 *
 * Three inputs, in order of freshness:
 *
 *   isBet             bets are free for everyone, always
 *   isPremium         the LIVE subscription, so an upgrade unlocks a
 *                     conversation in place rather than on next open
 *   canSendMessages   the server's answer as of the fetch, already stale if
 *                     the plan changed since — and absent on older payloads
 *
 * Any one being true is enough, and an ABSENT flag means allowed. Defaulting
 * the other way would hide the composer in a conversation the server would
 * have accepted, which is the worse failure: a wrongly shown composer produces
 * a clear error message, a wrongly hidden one looks like the feature is gone.
 */
export function canReplyInConversation(
  conversation: Pick<Conversation, 'isBet' | 'canSendMessages'>,
  isPremium: boolean,
): boolean {
  if (conversation.isBet === true) return true;
  if (isPremium) return true;
  return conversation.canSendMessages !== false;
}
